import { Box } from '@doltech/ui/lib/figma/Common/BoxV2';
import { RelatedPosts } from '@doltech/ui/lib/shared/components/RelatedPosts/RelatedPosts';
import * as React from 'react';

export const BlogRelatedPosts = ({ pageSeoInfo, relatedPosts }) => {
  return (
    <Box id="content-footer" bg="gray5" p="40px 0 40px">
      <RelatedPosts
        title={pageSeoInfo?.relatedPostsTitle}
        data={relatedPosts}
        readMore={{
          url: pageSeoInfo?.url,
          text: pageSeoInfo?.readMoreText,
        }}
      />
    </Box>
  );
};
